import React, { useState } from "react";
import { Apiurl, Encryption } from "../../Pages/utils/page";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ProductCountdown from "../Countdown/Countdown";
import "./FilterPageComponent.css";
const FilterPageComponent = ({
  filtersByCategory,
  filters,
  setFilters,
  GetProductsByFilter,
  dataByCategory,
  categoriesData,
  categorySelected,
  GetAllFiltersByCategory,
  setCategorySelected,
  isAnyFilterActive,
  handleClearAll,
}) => {
  const router = useNavigate();
  const [selectedOfferType, setSelectedOfferType] = useState(null);

  const handleBrandChange = (brand) => {
    setFilters((prev) => {
      const isSelected = prev.BrandNames.includes(brand);
      const updatedBrands = isSelected
        ? prev.BrandNames.filter((b) => b !== brand)
        : [...prev.BrandNames, brand];

      // Immediately call API with updated brands
      GetProductsByFilter({ ...prev, BrandNames: updatedBrands });

      return {
        ...prev,
        BrandNames: updatedBrands,
      };
    });
  };
  const handleSortChange = (e) => {
    const value = e.target.value;

    const updatedFilters = {
      ...filters,
      HighToLow: value === "HighToLow" ? true : null,
      LowToHigh: value === "LowToHigh" ? true : null,
    };

    setFilters(updatedFilters); // Update state
    GetProductsByFilter(updatedFilters); // Immediately use updated values
  };
  const handlePriceFromChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      LowestPrice: Number(e.target.value),
    }));
  };

  const handlePriceToChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      HighestPrice: Number(e.target.value),
    }));
  };

  const handleExpireChange = (type) => {
    // Toggle the value based on the current filter state
    const updatedFilters = {
      ...filters,
      ThisWeek: type === "This Week" ? !filters.ThisWeek : filters.ThisWeek,
      ThisMonth: type === "This Month" ? !filters.ThisMonth : filters.ThisMonth,
    };

    setFilters(updatedFilters); // Update state

    GetProductsByFilter(updatedFilters); // Call API with updated filters
  };
  const handleBidClick = () => {
    setSelectedOfferType("bid");
    setFilters((prev) => {
      const updatedFilters = {
        ...prev,
        IsProductInOffer: true,
      };
      GetProductsByFilter(updatedFilters);
      return updatedFilters;
    });
  };

  const handleBuyClick = () => {
    setSelectedOfferType("buy");
    setFilters((prev) => {
      const updatedFilters = {
        ...prev,
        IsProductInOffer: false,
      };
      GetProductsByFilter(updatedFilters);
      return updatedFilters;
    });
  };
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      <div className="background-bg-setion">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <div className="top-categories-section">
                <div className="top-categories-align-center">
                  {categoriesData?.map((i) => {
                    return (
                     
                      <div
                        className={
                          categorySelected == i?.Id
                            ? "select-cat text-center cate-spc-mx hover-effect"
                            : "normal-cat text-center cate-spc-mx hover-effect"
                        }
                        onClick={() => {
                          setCategorySelected(i?.Id);

                          GetAllFiltersByCategory(i);
                          router(`/filter/${Encryption(i?.Id)}`);
                          setFilters((prev) => {
                            const updatedFilters = {
                              ...prev,
                              CategoryId: i?.Id,
                            };

                            // 5. Call API with updated filters
                            GetProductsByFilter(updatedFilters);

                            return updatedFilters;
                          });
                        }}
                      >
                        <img
                          src={`/Images/${i?.Id}.jpg`}
                          alt={i?.CatgeoryName}
                          className="img-hover"
                        />
                        <p>{i?.CatgeoryName}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid container-spacing">
        <div className="filter-content-wraper">
          <div className="row">
            <div className="col-lg-2 col-5 filer-common-pd-0">
              <div id="sidebar-wrapper">
                <h4 class="common_heading">
                  FILTERS
                  {isAnyFilterActive() && (
                    <div
                      className="clear-all"
                      onClick={() => {
                        setSelectedOfferType(null);
                        handleClearAll();
                      }}
                    >
                      <span>CLEAR ALL</span>
                    </div>
                  )}
                </h4>

                <hr />
                {filtersByCategory?.BrandNames &&
                  filtersByCategory?.BrandNames.length > 1 && (
                    <div className="filter-section">
                      <h3>Brand</h3>
                      <ul>
                        {filtersByCategory?.BrandNames.map((item, index) => (
                          <li key={index}>
                            <input
                              type="checkbox"
                              id={`brand-${index}`}
                              checked={filters.BrandNames.includes(
                                item.BrandName
                              )}
                              onChange={() => handleBrandChange(item.BrandName)}
                            />
                            <label htmlFor={`brand-${index}`}>
                              {item?.BrandName}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                {filtersByCategory?.BusinessNames &&
                  filtersByCategory?.BusinessNames.length > 1 && (
                    <>
                      <div className="filter-section">
                        <h3>Business Name</h3>
                        <ul>
                          {filtersByCategory?.BusinessNames.map(
                            (item, index) => (
                              <li key={index}>
                                <input type="checkbox" id={`brand-${index}`} />
                                <label htmlFor={`brand-${index}`}>
                                  {item?.BusinessName}
                                </label>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                      <hr />
                    </>
                  )}

                <div className="flex justify-between items-center mb-4">
                  {filtersByCategory?.AvailableInOfferOrBuy.ProductsInBuy >=
                  2 ? (
                    <div>
                      <h3>
                        <label for="sortDropdown" class="font-semibold">
                          Sort By
                        </label>
                      </h3>
                      <select
                        id="sortDropdown"
                        className="border px-4 py-2 rounded-md ml-2 w-100"
                        onChange={handleSortChange}
                        value={
                          filters.HighToLow
                            ? "HighToLow"
                            : filters.LowToHigh
                            ? "LowToHigh"
                            : ""
                        }
                      >
                        <option value="">-- Select --</option>
                        <option value="HighToLow">Price: High to Low</option>
                        <option value="LowToHigh">Price: Low to High</option>
                      </select>
                <hr />

                    </div>
                  ) : null}
                </div>
                {filtersByCategory?.HighestPrice != 0 ? (
                  <>
                    <div className="filter-section">
                      <h3>Price</h3>
                      <div className="d-flex  align-items-center">
                        <div>
                          <input
                            type="range"
                            min={filtersByCategory?.LowestPrice}
                            max={filtersByCategory?.HighestPrice}
                            step="1"
                            className="form-range price-ramge"
                            value={
                              filters.LowestPrice ||
                              filtersByCategory?.LowestPrice
                            }
                            onChange={handlePriceFromChange}
                          />

                          <input
                            type="range"
                            min={filtersByCategory?.LowestPrice}
                            max={filtersByCategory?.HighestPrice}
                            step="1"
                            className="form-range price-ramge"
                            value={
                              filters.HighestPrice ||
                              filtersByCategory?.HighestPrice
                            }
                            onChange={handlePriceToChange}
                          />
                        </div>
                        <div>
                          <button
                            class="common_btn_new go-btn-spc"
                            onClick={() =>
                              GetProductsByFilter({
                                ...filters,
                                LowestPrice:
                                  filters.LowestPrice ||
                                  filtersByCategory?.LowestPrice, // Fallback to LowestPrice if PriceFrom is null
                                HighestPrice:
                                  filters.HighestPrice ||
                                  filtersByCategory?.HighestPrice, // Fallback to HighestPrice if PriceTo is null
                              })
                            }
                          >
                            Go
                          </button>
                        </div>
                      </div>
                      <div>
                        ₹{filters.LowestPrice || filtersByCategory?.LowestPrice}{" "}
                        - ₹
                        {filters.HighestPrice ||
                          filtersByCategory?.HighestPrice}
                      </div>
                    </div>
                    <hr />
                  </>
                ) : null}

                <div className="filter-section">
                  <h3>AVAILABILITY</h3>
                  <ul>
                    <li>
                      <input
                        type="checkbox"
                        checked={filters.IsStockAvailable === true}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFilters((prev) => {
                            const updatedFilters = {
                              ...prev,
                              IsStockAvailable: isChecked ? true : null,
                            };
                            GetProductsByFilter(updatedFilters); // Call function with updated filters
                            return updatedFilters;
                          });
                        }}
                      />{" "}
                      <label for="availablity">Include Only In Stock</label>
                    </li>
                  </ul>
                </div>
                <hr />
                {filtersByCategory?.ThisWeekOrMonth && (
                  <>
                    <div className="filter-section">
                      <h3>EXPIRE IN</h3>
                      <ul>
                        {filtersByCategory?.ThisWeekOrMonth?.split(",").map(
                          (item, index) => {
                            const trimmedItem = item.trim();
                            const isChecked =
                              (trimmedItem === "This Week" &&
                                filters.ThisWeek) ||
                              (trimmedItem === "This Month" &&
                                filters.ThisMonth);

                            return (
                              <li key={index}>
                                <input
                                  type="checkbox"
                                  id={`expire-${index}`}
                                  checked={isChecked}
                                  onChange={() =>
                                    handleExpireChange(trimmedItem)
                                  }
                                />
                                <label htmlFor={`expire-${index}`}>
                                  {trimmedItem}
                                </label>
                              </li>
                            );
                          }
                        )}
                      </ul>
                    </div>
                    <hr />
                  </>
                )}
              </div>
            </div>
            <div className="col-lg-10 col-7 filer-common-pd-0 background-bg-setion">
              {filtersByCategory?.AvailableInOfferOrBuy?.ProductsInOffer >=
                1 && (
                <>
                  <div>
                    <button
                      type="button"
                      className={`common-product-btn ${
                        selectedOfferType === "bid" ? "active-btn" : ""
                      }`}
                      onClick={handleBidClick}
                    >
                      Bid Products
                    </button>
                    <button
                      type="button"
                      className={`common-product-btn ${
                        selectedOfferType === "buy" ? "active-btn" : ""
                      }`}
                      onClick={handleBuyClick}
                    >
                      Buy Products
                    </button>
                  </div>
                </>
              )}

              <div className="product-rgt-area-inner-wraper">
                <div className="row">
                  {dataByCategory?.length ? (
                    dataByCategory?.map((item) => {
                      const imagesArray = JSON.parse(item?.Images);

                      const defaultImage = imagesArray.find(
                        (img) => img.Default
                      );

                      const imageUrl = defaultImage
                        ? `${Apiurl()}/${defaultImage.Images}`
                        : "";
                      const now = moment(); // Current time
                      const timeTo = moment(item?.ToPublishDate);
                      const timeDifferenceInHours = timeTo.diff(now, "hours");

                      return (
                        <div class="col-lg-2 vendor_related_pro_spc product_new_btm_spc">
                          <div class="pro_detail_wrapper_new_section text-center">
                            <img
                              src={imageUrl}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/Images/no-product-img-700.jpg";
                              }}
                              onClick={() => {
                                router(
                                  `/productdetail/${Encryption(item?.Id)}`
                                );
                              }}
                            />
                            <h2>{item?.ProductName} </h2>
                            <h3>
                              {moment(item.ProductToPublishDate).format(
                                "DD MMM YYYY, hh:mm A"
                              )}
                            </h3>
                            {/* {timeDifferenceInHours > 24 ? (
                              <h3>
                                Till:{" "}
                                {moment(item?.DealPriceDeclareDate).format(
                                  "LL"
                                )}
                              </h3>
                            ) : (
                              <h3>
                                <ProductCountdown item={item} val="tillTime" />
                              </h3>
                            )} */}
                            {item?.IsProductInOffer == true ? (
                              <>
                                <h5>₹{item?.Mrp}</h5>
                              </>
                            ) : (
                              <>
                                <h5>
                                  {" "}
                                  ₹ {item?.DealPrice}{" "}
                                  <span className="mrp-price">
                                    ₹{item?.Mrp}
                                  </span>
                                  <span className="flat-dicsount">
                                    {" "}
                                    50% off
                                  </span>
                                </h5>
                              </>
                            )}

                            {item?.IsProductOutOfStock === true ? (
                              <input
                                type="button"
                                value="Out of Stock"
                                className="common_btn_new out_stock_btn_01"
                              />
                            ) : (
                              <input
                                type="button"
                                onClick={() => {
                                  router(
                                    `/productdetail/${Encryption(item?.Id)}`
                                  );
                                }}
                                value={
                                  item?.IsProductInOffer == true
                                    ? "Bid Now"
                                    : item?.IsProductInOffer == false
                                    ? "Buy Now"
                                    : item?.IsProductInOffer == null
                                    ? "Contact Us"
                                    : null
                                }
                                className={
                                  item?.IsProductInOffer == true
                                    ? "common_btn_new bid_now_btn_01"
                                    : item?.IsProductInOffer == false
                                    ? "common_btn_new"
                                    : item?.IsProductInOffer == null
                                    ? "common_btn_new"
                                    : null
                                }
                              />
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p>No Result</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPageComponent;
